import { formatCPFOrCNPJ, validCNPJ } from '../../utils/document';
import Address from './address';

export default class User {
  public static ROLE_ADMIN = 'ROLE_ADMIN';
  public static ROLE_USER = 'ROLE_USER';

  acceptNewsletter = false;
  addressDelivery?: Address;
  addressInvoicing?: Address;
  birthDate?: string;
  confirmPassword?: string;
  createdAt?: string;
  document?: string;
  email?: string;
  id?: number;
  isAdmin = false;
  isCompany = false;
  lastName?: string;
  name?: string;
  password?: string;
  phone?: string;
  roles?: Array<any> = [];
  type?: string;

  fromJson(user: any) {
    if (user) {
      this.id = user?.id;
      this.name = this.getFullName(user) || '';
      this.document = user?.document || '';
      this.isCompany = user?.isCompany || validCNPJ(this.document || '');
      this.phone = this.formatPhone(user?.phone) || '';
      this.birthDate = user?.birthDate || '';
      this.email = user?.email || '';
      this.password = user?.password || '';
      this.createdAt = user?.createdAt || '';
      this.acceptNewsletter = user?.acceptNewsletter;

      let newAddressDelivery: Address;
      newAddressDelivery = new Address();
      newAddressDelivery.fromJson(user.addressDelivery);
      this.addressDelivery = newAddressDelivery;

      if (user.addressInvoicing) {
        let newAddressInvoicing: Address;
        newAddressInvoicing = new Address();
        newAddressInvoicing.fromJson(user.addressInvoicing);
        this.addressInvoicing = newAddressInvoicing;
      }

      this.roles = [];
      user?.roles?.forEach((role: any) => {
        if (role.name === User.ROLE_ADMIN) {
          this.isAdmin = true;
        }
        this.roles?.push(role);
      });
      this.type = this.isAdmin ? 'Admin' : 'Cliente';
    }
  }

  getIsAdmin(): boolean {
    const roleAdmin = this.roles?.find((role) => role.name === User.ROLE_ADMIN);
    return roleAdmin != null;
  }

  formatPhone(phone: string): string {
    if (!phone) return '';

    const digits = phone.replace(/\D/g, '');

    if (digits.length === 11) {
      return digits.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    }

    if (digits.length === 10) {
      return digits.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    }

    return phone;
  }

  private getFullName(user: User): string {
    const name = user?.name?.trim();
    const lastName = user?.lastName?.trim();

    if (lastName) {
      return `${name} ${lastName}`;
    } else {
      return name || '';
    }
  }

  documentFormat() {
    return formatCPFOrCNPJ(this.document || '');
  }
}
